import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { GrowthConsole } from './pages/GrowthConsole';
import { DealerDashboard } from './pages/DealerDashboard';
import { MasterCreativeEditing } from './pages/MasterCreativeEditing';
import { CampaignSetup } from './pages/CampaignSetup';
import { CreativeSelection } from './pages/CreativeSelection';
import { StylingTemplate } from './pages/StylingTemplate';
import { VariableContent } from './pages/VariableContent';
import { GenerateCreatives } from './pages/GenerateCreatives';
import { ReviewPublish } from './pages/ReviewPublish';
import { DealerCreativeDashboard } from './pages/dealer/DealerCreativeDashboard';
import { SelectCarModel } from './pages/dealer/SelectCarModel';
import { ChooseBackground } from './pages/dealer/ChooseBackground';
import { AddGreetings } from './pages/dealer/AddGreetings';
import { AddDealerInfo } from './pages/dealer/AddDealerInfo';
import { GenerateCreative } from './pages/dealer/GenerateCreative';
import { ChooseOutputFormat } from './pages/dealer/ChooseOutputFormat';
import { ResizerUpload } from './pages/dealer/ResizerUpload';
import { ResizerFormats } from './pages/dealer/ResizerFormats';
import { VideoUpload } from './pages/dealer/video-generator/VideoUpload';
import { VideoConfiguration } from './pages/dealer/video-generator/VideoConfiguration';
import { VideoGeneration } from './pages/dealer/video-generator/VideoGeneration';
import { VideoPreview } from './pages/dealer/video-generator/VideoPreview';
import { LeadsManagement } from './pages/LeadsManagement';
import { Conversations } from './pages/Conversations';
import { Workflows } from './pages/Workflows';
import { Settings } from './pages/Settings';
import { BrandDashboard } from './pages/brand/BrandDashboard';
import { PartnerManagement } from './pages/brand/PartnerManagement';
import { CampaignTemplates } from './pages/brand/CampaignTemplates';
import { ComplianceDashboard } from './pages/brand/ComplianceDashboard';
import { BrandAssets } from './pages/brand/BrandAssets';
export function AppRouter() {
  return <BrowserRouter data-id="element-9">
      <Routes data-id="element-10">
        <Route path="/" element={<App data-id="element-12" />} data-id="element-11" />

        {/* Brand Management Routes */}
        <Route path="/brand/dashboard" element={<BrandDashboard data-id="element-14" />} data-id="element-13" />
        <Route path="/brand/partners" element={<PartnerManagement data-id="element-16" />} data-id="element-15" />
        <Route path="/brand/templates" element={<CampaignTemplates data-id="element-18" />} data-id="element-17" />
        <Route path="/brand/compliance" element={<ComplianceDashboard data-id="element-20" />} data-id="element-19" />
        <Route path="/brand/assets" element={<BrandAssets data-id="element-22" />} data-id="element-21" />

        {/* Growth Console Route */}
        <Route path="/growth-console" element={<GrowthConsole data-id="element-24" />} data-id="element-23" />

        {/* Campaigns Route */}
        <Route path="/campaigns" element={<App data-id="element-26" />} data-id="element-25" />

        {/* Leads Management Route */}
        <Route path="/leads" element={<LeadsManagement data-id="element-28" />} data-id="element-27" />

        {/* New Routes */}
        <Route path="/conversations" element={<Conversations data-id="element-30" />} data-id="element-29" />
        <Route path="/workflows" element={<Workflows data-id="element-32" />} data-id="element-31" />

        {/* Settings Routes with nested routes */}
        <Route path="/settings/*" element={<Settings data-id="element-34" />} data-id="element-33" />

        {/* Dealerization Flow Routes */}
        <Route path="/dealerization" element={<DealerDashboard data-id="element-36" />} data-id="element-35" />
        <Route path="/dealerization/step-0" element={<MasterCreativeEditing data-id="element-38" />} data-id="element-37" />
        <Route path="/dealerization/step-1" element={<CampaignSetup data-id="element-40" />} data-id="element-39" />
        <Route path="/dealerization/step-2" element={<CreativeSelection data-id="element-42" />} data-id="element-41" />
        <Route path="/dealerization/step-3" element={<StylingTemplate data-id="element-44" />} data-id="element-43" />
        <Route path="/dealerization/step-4" element={<VariableContent data-id="element-46" />} data-id="element-45" />
        <Route path="/dealerization/step-5" element={<GenerateCreatives data-id="element-48" />} data-id="element-47" />
        <Route path="/dealerization/step-6" element={<ReviewPublish data-id="element-50" />} data-id="element-49" />

        {/* Creative Customizer Routes */}
        <Route path="/creative-customizer" element={<DealerCreativeDashboard data-id="element-52" />} data-id="element-51" />
        <Route path="/dealer/creative-customizer" element={<DealerCreativeDashboard data-id="element-54" />} data-id="element-53" />

        {/* AI Creative Generator Flow */}
        <Route path="/dealer/ai-generator/step-1" element={<SelectCarModel data-id="element-56" />} data-id="element-55" />
        <Route path="/dealer/ai-generator/step-2" element={<ChooseBackground data-id="element-58" />} data-id="element-57" />
        <Route path="/dealer/ai-generator/step-3" element={<AddGreetings data-id="element-60" />} data-id="element-59" />
        <Route path="/dealer/ai-generator/step-4" element={<AddDealerInfo data-id="element-62" />} data-id="element-61" />
        <Route path="/dealer/ai-generator/step-5" element={<GenerateCreative data-id="element-64" />} data-id="element-63" />
        <Route path="/dealer/ai-generator/step-6" element={<ChooseOutputFormat data-id="element-66" />} data-id="element-65" />

        {/* Creative Resizer Flow */}
        <Route path="/dealer/resizer/step-1" element={<ResizerUpload data-id="element-68" />} data-id="element-67" />
        <Route path="/dealer/resizer/step-2" element={<ResizerFormats data-id="element-70" />} data-id="element-69" />

        {/* Image to Video Generator Flow */}
        <Route path="/dealer/video-generator/upload" element={<VideoUpload data-id="element-72" />} data-id="element-71" />
        <Route path="/dealer/video-generator/configure" element={<VideoConfiguration data-id="element-74" />} data-id="element-73" />
        <Route path="/dealer/video-generator/generate" element={<VideoGeneration data-id="element-76" />} data-id="element-75" />
        <Route path="/dealer/video-generator/preview" element={<VideoPreview data-id="element-78" />} data-id="element-77" />
      </Routes>
    </BrowserRouter>;
}